/**
 * PGSS-5659: in the Create Supplier Order dialog the product name is the description the user orders
 * from, so it must be readable in full: it wraps onto more lines instead of being cut off at 200px
 * with "...". The order / quote / RFQ product lists keep their one-line, truncated name.
 *
 * PGSS-5663: it is still a link in both places. In Create Supplier Order it opens View Product in the
 * second dialog slot (viewProductDialog), stacked on top, so the order dialog keeps its state.
 */
export const WRAPPED_PRODUCT_NAME_TYPES = ['supplierOrder', 'supplierOrderDirectShipment'];

export function wrapsProductName(type) {
  return WRAPPED_PRODUCT_NAME_TYPES.includes(type);
}

export function productNameStyle(type, color) {
  if (wrapsProductName(type)) {
    // Link colour like the other lists (it opens View Product). Wrap between words only ('break-word' splits a word solely when it cannot fit any line), and keep
    // a minimum width. 'anywhere' let the table shrink the column to about one character, because it
    // makes every letter a break point (PGSS-5659 follow-up).
    return { color, whiteSpace: 'normal', overflowWrap: 'break-word', wordBreak: 'normal', minWidth: '260px' };
  }
  return {
    color,
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '200px',
  };
}
